import { Card as SemanticCard } from 'semantic-ui-react';

import Course from './Course';
import UserCourse from './UserCourse';
import Base from './Base';
import LibraryCourse from './LibraryCourse';
import Member from './Member';
import UserPager from './UserPager';
import PublicPager from './PublicPager';
import Company from './Company';

export default class Card extends SemanticCard {
  static Course = Course;
  static UserCourse = UserCourse;
  static LibraryCourse = LibraryCourse;
  static Base = Base;
  static Member = Member;
  static UserPager = UserPager;
  static PublicPager = PublicPager;
  static Company = Company;
}
